
function AdminUserMgmt() {
    let transactionManagement = [
        {
            name: "Transaction User Management",
            icon: "Wallet-management",
            logoName: "MyAccounts",
            // flag: "voucherRequired",
            displayService: "adminUserManagementData",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/AdminUser-Management",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    // const walletManagementSub = () => {
    //   const profileArr = [
    //     {
    //       path: "/index/WalletTransaction",
    //       name: "Transactions",
    //       icon: "WalletManagement",
    //       logoName: "wallet transaction",
    //       // flag: "isProfileSetting",
    //     },
    //   ];


    //   return profileArr;

    // };
    const admin_Transaction = () => {
        const TransactionArr = [
            {
                path: "/index/AdminTransaction",
                name: "Transaction",
                icon: "WalletManagement",
                logoName: "wallet transaction",
                // flag: "isProfileSetting",
            },
        ];
        return TransactionArr;

    }


    let a = dashboard();
    // let b = walletManagementSub();
    let b = admin_Transaction()

  

    transactionManagement[0].items = [...a, ...b];

    return transactionManagement;
}

export default AdminUserMgmt;
